import { XIcon } from '@phosphor-icons/react';
import type { MouseEventHandler } from 'react';

import styles from './close-button.module.scss';

export type CloseButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
  /**
   * `dark` is the Neutral/950 disc with a white glyph the design system's own CloseButton ships
   * over imagery (Figma `1158:611330`, the evidence image lightbox). Geometry is identical — only
   * the colourway differs, which is why this is a tone and not a second component.
   */
  tone?: 'default' | 'dark';
};

export function CloseButton({
  onClick,
  disabled,
  'aria-label': ariaLabel = 'Close',
  className,
  tone = 'default',
}: CloseButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      className={[styles.closeButton, tone === 'dark' && styles.dark, className]
        .filter(Boolean)
        .join(' ')}
    >
      <XIcon />
    </button>
  );
}
